import CheckIcon from "../../assets/svg/v1/check-icon";
import MarkChatReadIcon from "../../assets/svg/solid-icons/mark-chat-read-icon";
import WarningIcon from "../../assets/svg/warning-icon";
import CrossCircleIcon from "../../assets/svg/v1/cross-circle-icon";
import MailUnsubscribeIcon from "../../assets/svg/solid-icons/mail-unsubscribe-icon";
import ReplyIcon from "../../assets/svg/reply-icon";

export interface StatusHistoryItem {
  status: string;
  timestamp: string;
}

export interface MessageStatusConfig {
  icon: React.FC<{ className?: string }>;
  label: string;
  color: string;
  darkColor: string;
}

export const MESSAGE_STATUS_CONFIG: Record<string, MessageStatusConfig> = {
  sent: {
    icon: CheckIcon,
    label: "Sent",
    color: "text-gray-placeholder",
    darkColor: "dark:text-gray-placeholder-dk",
  },
  delivered: {
    icon: MarkChatReadIcon,
    label: "Delivered",
    color: "text-gray-placeholder",
    darkColor: "dark:text-gray-placeholder-dk",
  },
  processing: {
    icon: MarkChatReadIcon,
    label: "Delivered",
    color: "text-gray-placeholder",
    darkColor: "dark:text-gray-placeholder-dk",
  },
  read: {
    icon: MarkChatReadIcon,
    label: "Read",
    color: "text-verba-blue",
    darkColor: "dark:text-verba-blue-dk",
  },
  bounced: {
    icon: WarningIcon,
    label: "Bounced",
    color: "text-[#eac11d]",
    darkColor: "dark:text-[#eac11d]",
  },
  failed: {
    icon: CrossCircleIcon,
    label: "Failed",
    color: "text-verba-red-alert",
    darkColor: "dark:text-verba-red-alert-dk",
  },
  unsubscribed: {
    icon: MailUnsubscribeIcon,
    label: "Unsubscribed",
    color: "text-verba-red-alert",
    darkColor: "dark:text-verba-red-alert-dk",
  },
  replied: {
    icon: ReplyIcon,
    label: "Replied",
    color: "text-[#10b981]",
    darkColor: "dark:text-[#10b981]",
  },
};
